module.exports = __webpack_public_path__ + "static/media/diving_1366.fcba06d7.webp";